<template>
    <div class="rates-detail-container">
        <div
            class="rates-detail-item"
            v-for="distribution in rates.rateDistributions"
            :key="distribution._uid"
        >
            <div v-if="distribution.employer">
                <typo name="body-14-normal" v-if="distribution.employer.value">
                    Employeur : {{ distribution.employer.value }}
                    {{ getOptionLabel(distribution.employer.unit) }}
                </typo>
                <typo name="body-14-normal"> {{ getMinMaxLabel(distribution.employer) }} </typo>
            </div>
            <div v-if="distribution.employee">
                <typo name="body-14-normal" v-if="distribution.employee.value">
                    Salarié : {{ distribution.employee.value }}
                    {{ getOptionLabel(distribution.employee.unit) }}
                </typo>
                <typo name="body-14-normal"> {{ getMinMaxLabel(distribution.employee) }} </typo>
            </div>
            <div>
                <typo name="body-14-normal" v-if="distribution.salaryBase">
                    Assiette : {{ getOptionLabel(distribution.salaryBase) }}
                </typo>
            </div>
        </div>
    </div>
</template>

<script>
import { get } from "lodash";

export default {
    props: ["rates", "annotationOptions"],
    methods: {
        getOptionLabel(code) {
            return get(this.annotationOptions, `${code}.label`, "");
        },
        getMinMaxLabel(distribution) {
            if (!distribution) {
                return "";
            }
            if (distribution.min) {
                return "Minimum";
            }
            if (distribution.max) {
                return "Maximum";
            }
            return "";
        },
    },
};
</script>

<style scoped lang="sass">
.rates-detail-container
    display: flex
    flex-direction: column
    width: 250px
    margin: 0 16px
    padding: 0 16px
.rates-detail-item
    display: flex
    flex-direction: column
    margin: 8px 0
</style>
